import React, { useContext } from 'react';
import { signUpContext } from '../../../pages/signup';
import { Link } from 'react-router-dom';
import BlueButton from '../../../components/ui/BlueButton';
import { Formik, Form, ErrorMessage, Field } from "formik";
import * as Yup from "yup";
import styles from './SignUp.module.css';



const SignUpSeeker = () => {
    const { setNext, setMail } = useContext(signUpContext);
    const initialValues = {
      email: "",
    };
    const onSubmit = (values) => {
      console.log("onSubmit", values);
      setMail(values.email);
      setNext(2);//next page

    };
    // const onSubmit = (data) => {
    //   axios.post("http://localhost:3001/auth", data).then(() => {
    //     console.log(data);
    //     window.location="/login"; 
    //   });
    // };
  
    const validationSchema = Yup.object({
      email: Yup.string().required("Email is required").email("Invalid email adress"),
    });
    
    return (<>             
      <h1>Sign Up as a Project Seeker</h1>
      <div className={styles.container}>
        
        <Formik
          initialValues={initialValues}
          onSubmit={onSubmit}
          validationSchema={validationSchema}
        >
          {() => (
            <Form>
              <div >
                <Field className={styles.input} name="email" placeholder="Email Id" />
                <div className="error">
                  <ErrorMessage name="email" component="span" />
                </div>
              </div>
              <BlueButton extraStyle={{width: '100%'}}type={'submit'}><p>SignUp</p></BlueButton>
            </Form>
          )}
        </Formik>
        <div className={styles.container2}><p>Already Have an account?</p><Link to='/login'>Login</Link></div>
        <div >
        <BlueButton extraStyle={{width: '100%', display: 'flex', alignItems: 'center'}}type={'submit'} onClick={onSubmit}><img className={styles.googleSvg} src="GoogleLogo.svg" alt="Google logo" />SignUp with Google</BlueButton>
        </div>

      </div>
        </>
        )
  }

export default SignUpSeeker;